export const EVENT_EXPIRATION_AFTER_SELLER_IS_DISCONNECTED_IN_SECONDS_REFERENCE_DATA_ID = 385;
export const ENABLE_VIDEO_COMPOSITION_REFERENCE_DATA_ID = 353;
export const REQUIRED_PHONE_NUMBER_REFERENCE_DATA = 466;
